import React, { useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Paper, Tab, Tabs } from "@mui/material";
import { AuthContext } from "common/AuthProvider";
import { Role } from "common/Constants";
import ReviewQueue from "./ReviewQueue";
import EventResetsTab from "./EventResetsTab";
import { EVENT_RESETS_TAB } from "./eventResets";

const QUEUE_TAB = "queue";

// The review queue, plus an Admin-only "Event Resets" tab: the history and live state of bulk Event
// Resets started from this queue. Non-admins get the queue alone; the tab is not rendered for them
// (OrderApi refuses them the history as well). The tab is in the URL (?tab=resets&batch=<id>) so a
// run can be linked to. The queue stays mounted while the other tab is open, so a bulk reset running
// in the background keeps reporting its progress.
const ReviewQueuePage: React.FC = () => {
  const { isUserInRole } = useContext(AuthContext);
  const isAdmin = isUserInRole(Role.Admin);
  const [params, setParams] = useSearchParams();

  if (!isAdmin) return <ReviewQueue />;

  const tab = params.get("tab") === EVENT_RESETS_TAB ? EVENT_RESETS_TAB : QUEUE_TAB;
  const select = (value: string) => {
    const next = new URLSearchParams(params);
    if (value === QUEUE_TAB) {
      next.delete("tab");
      next.delete("batch");
    } else {
      next.set("tab", value);
    }
    setParams(next);
  };

  return (
    <>
      <Paper sx={{ mb: 1, borderRadius: "4px 4px 0 0" }}>
        <Tabs value={tab} onChange={(_, value) => select(value)} aria-label="Review queue views">
          <Tab value={QUEUE_TAB} label="Review Queue" className={tab === QUEUE_TAB ? "tab tab-active" : "tab"} data-testid="tab-review-queue" />
          <Tab value={EVENT_RESETS_TAB} label="Event Resets" className={tab === EVENT_RESETS_TAB ? "tab tab-active" : "tab"} data-testid="tab-event-resets" />
        </Tabs>
      </Paper>
      <Box sx={{ display: tab === QUEUE_TAB ? "block" : "none" }}>
        <ReviewQueue />
      </Box>
      {tab === EVENT_RESETS_TAB && <EventResetsTab />}
    </>
  );
};

export default ReviewQueuePage;
